import { render, staticRenderFns } from "./SpeciesList.vue?vue&type=template&id=d803aa00&scoped=true&"
import script from "./SpeciesList.vue?vue&type=script&lang=js&"
export * from "./SpeciesList.vue?vue&type=script&lang=js&"
import style0 from "./SpeciesList.vue?vue&type=style&index=0&id=d803aa00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d803aa00",
  null
  
)

export default component.exports